import React, { useState } from 'react';
import {
  MDBBtn,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBInput
}
from 'mdb-react-ui-kit';
import { enqueueSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { UserChangePwdInterface, userForgorPwd } from '../../Const/type';
import { CustomMessage } from '../../Const/Spinner';
import { setLoading } from '../../Redux/CommonSlice';
import { forgotPasswordChange } from '../../Const';
import krishcaLogo from "../../assets/krishca.jpg";
import vedantaLogo from "../../assets/vedanta.jpg";
import EmailIcon from '@mui/icons-material/Email';

const ForgotPassword:React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [userLogin,setUserLogin] = useState<userForgorPwd>({
    username: ""
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e?.target;
    const updatedUserLogin = {...userLogin};
      updatedUserLogin[name] = value;
    setUserLogin(updatedUserLogin);
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e?.preventDefault();
    if(userLogin?.username === ""){
      CustomMessage("Enter the required field",'error',enqueueSnackbar);
      return;
    }
    dispatch(setLoading(true));
    try{
      const response = await forgotPasswordChange(userLogin);
      const {data,status} = response;
      if(status.code === 200){
        CustomMessage(status.message,'success',enqueueSnackbar);
        navigate("/");
        CustomMessage("Login now with generated password",'info',enqueueSnackbar);
      }else{
        CustomMessage(status.message,'error',enqueueSnackbar);
      }
    }catch(error:any){
      CustomMessage(error?.message,'error',enqueueSnackbar);
    }finally{
      dispatch(setLoading(false));
    }
  }

  return (
    <MDBContainer fluid className="login-container px-3 px-md-5">
      <MDBRow>
          {/* Left Section - Branding and Content */}
        <MDBCol md="6" className="login-image-section py-0">
          <div className="logo-container mb-0">
            <img src={krishcaLogo} className="login-logo1" loading="lazy"/>
            <img src={vedantaLogo} alt="Logo 2" className="login-logo2" loading='lazy' />
          </div>
          <h1 className="app-tagline text-uppercase">Welcome to Krishca <br />Logistics App</h1>
          <p className="app-description mb-3 mb-md-0">
            KRISHCA LOGISTICS, developed by Krishca Strapping Solutions, designed to enhance operations for Vedanta Aluminum Ltd. This app offers real-time tracking, standardize operations, and streamlined logistics management, ensuring efficient and secure transport.
          </p>
        </MDBCol>

          {/* Right Section - Login Form */}
        <MDBCol md="6" className="login-form-section py-0">
          <MDBCard className="login-card">
            <MDBCardBody className="text-white">
              <h2 className="fw-bold mb-2 text-center text-uppercase">Forgot password</h2>
              <p className="text-center mb-5 lh-normal">
                Please enter your Username!
              </p>
              <form onSubmit={handleSubmit}>
                <div className="mb-4 position-relative input-wrapper">
                  <EmailIcon className="login-icon" />
                  <MDBInput
                      labelClass='text-white'
                      label='Email address'
                      placeholder="Email Address"
                      id='formControlLg'
                      type='email'
                      size="lg"
                      required
                      value={userLogin.username}
                      name='username'
                      onChange={handleChange}
                  />
                </div>
                <p className="small text-end">
                  <a href="#" onClick={()=>navigate("/")} className="text-white">
                    Back to Login?
                  </a>
                </p>
                <MDBBtn className="w-100 mb-0 shadow-none text-capitalize fw-medium" size="lg">
                  Submit
                </MDBBtn>

                {/*<MDBRow className='d-flex justify-content-center align-items-center h-100'>*/}
                  {/*<MDBCol col='12'>*/}
                    {/*<MDBCard className='bg-dark text-white my-5 mx-auto' style={{borderRadius: '1rem', maxWidth: '400px'}}>*/}
                      {/*<MDBCardBody className='p-5 d-flex flex-column align-items-center mx-auto w-100'>*/}

                        {/*<p className="small mb-3 pb-lg-2"><a className="text-white-50" href="#" onClick={()=>navigate("/")}>Login !</a></p>*/}
                        {/*<MDBBtn outline className='mx-2 px-5 text-white' size='lg'>*/}
                          {/*Submit*/}
                        {/*</MDBBtn>*/}
                      {/*</MDBCardBody>*/}
                    {/*</MDBCard>*/}
                  {/*</MDBCol>*/}
                {/*</MDBRow>*/}
              </form>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
}

export default ForgotPassword;